<template>
  <div>
    <h3 style="margin-top: 30px">Listado de Equipos del Cliente</h3>
    <el-table
      :data="
        Math.ceil(this.deviceTotal / this.pageSize) <= 1
          ? paginataionDevices
          : paginataionDevices[currentPage]
      "
      v-loading="loading"
      :row-class-name="highlightSelectedDevice"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="DescriptionLine" label="Descripción de Equipo" />
      <el-table-column prop="SIMNumber" label="SIM" />
      <el-table-column prop="Serial" label="Serial" />
      <el-table-column type="selection" />
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="deviceTotal"
    >
    </el-pagination>

    <el-form
      style="margin-top: 30px"
      v-if="
        devicesList.length > 0 &&
        rowData.ServiceRequestType.Description == 'Cambio de Equipo'
      "
    >
      <h3 style="margin-top: 30px">Edición de Equipos</h3>
      <el-row :gutter="20">
        <el-col :span="7">
          <span> Descripción de Equipo </span>
        </el-col>
        <el-col :span="4">
          <span> SIM </span>
        </el-col>
        <el-col :span="4">
          <span> Serial </span>
        </el-col>
      </el-row>
      <el-row
        v-for="(installation, rowIndex) in devicesList.length"
        :key="rowIndex"
        :gutter="20"
      >
        <el-col :span="7">
          <el-input
            v-model="devicesList[rowIndex].DescriptionLine"
            placeholder="CommentTitle"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-select
              v-model="devicesList[rowIndex].SIMNumber"
              placeholder="SIM"
              filterable
              v-loading="simLoading"
              @change="handleSimChange"
            >
              <el-option
                v-for="(item, itemIndex) in simList"
                :key="item.PhoneNumber"
                :label="item.PhoneNumber"
                :value="{ SIM: item, itemIndex: itemIndex, rowIndex: rowIndex }"
              >
              </el-option
            ></el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-select
              v-model="devicesList[rowIndex].Serial"
              placeholder="Serial"
              filterable
              v-loading="serialLoading"
              @change="handleSerialChange"
            >
              <el-option
                v-for="(item, itemIndex) in serialList"
                :key="itemIndex"
                :label="item.Serial"
                :disabled="item.disabled"
                :value="{
                  serial: item,
                  itemIndex: itemIndex,
                  rowIndex: rowIndex
                }"
              >
              </el-option
            ></el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { formatArrayToElSelect } from "@/utils";
export default {
  name: "AssignTechnicianUninstallationForm",
  props: {
    rowData: {
      type: Object
    },
    SelectedTechnician: {
      type: Number
    },
    Tab: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      customerDevices: [],
      devicesList: [],
      devicesColumns: [
        {
          prop: "DescriptionLine",
          label: "Descripción de Dispositivo"
          //   sortable: true,
          //   width: 155,
          //   fixed: true
        },
        {
          prop: "SIMNumber",
          label: "SIM"
          //   sortable: true,
          //   width: 155,
          //   fixed: true
        },
        {
          prop: "Serial",
          label: "Serial"
          //   sortable: true,
          //   width: 155,
          //   fixed: true
        },
        {
          prop: "",
          width: 65,
          type: "selection"
          // formatter: ButtonInLineFormatter,
          // attrs: {
          //   icon: "el-icon-delete",
          //   buttonType: "danger",
          //   onClick: this.unistallDevices
          // }
        }
      ],

      //DATA DE LOS SELECTORES
      technicians: [],
      modelsList: [],
      modelLoading: false,
      serialList: [],
      serialLoading: false,
      simList: [],
      simLoading: false,
      selectedSIMs: [],
      selectedSerial: [],

      //PAGINACION
      deviceTotal: 0,
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 40, 50, 100],
      paginataionDevices: []
    };
  },
  mounted() {
    if (this.rowData.Id) {
      this.getCustomerDevices();
    }
  },
  methods: {
    getCustomerDevices() {
      this.loading = true;
      this.$http
        .get(
          `/api/serviceRequests/CustomerDevicesToUnistall?clientCode=${this.rowData.ClientCode}&contractNo=${this.rowData.ContractCode}`
        )
        .then((resp) => {
          this.customerDevices = resp.data;
          this.deviceTotal = this.customerDevices.length;
          let pagesAmount = Math.ceil(this.deviceTotal / this.pageSize);
          let paginationIndex = 0;
          if (pagesAmount == 1) {
            this.paginataionDevices = resp.data;
          } else {
            for (let index = 0; index <= pagesAmount; index++) {
              var pageData = this.customerDevices.splice(
                paginationIndex,
                this.pageSize - 1
              );
              this.paginataionDevices.push(pageData);
            }
          }

          this.loading = false;
        });
      this.getAvailableDevices();
      this.getAvailableSims();
    },
    handleSelectionChange(devices) {
      devices.forEach((dev) => {
        dev.IsEnabled = false;
      });

      this.devicesList.forEach((dev) => {
        const found = devices.find((f) => f == dev);
        //if not found then enable it
        if (!found) {
          dev.IsEnabled = true;
        }
      });

      this.devicesList = devices;
    },
    selectedDevicesList() {
      return {
        LocationCode: this.rowData.Product.Codes,
        RequestId: this.rowData.Id,
        UserId: this.currentUser.UserID,
        Request: this.rowData,
        DesinstalationRequests: this.devicesList
      };
    },
    highlightSelectedDevice(selected) {
      if (!selected.row.IsEnabled) {
        return "warning-row";
      }
    },
    clearData() {
      //Se usa en el componente padre. (RequestList.vue)
      this.devicesList = [];
      this.customerDevices = [];
      this.technicians = [];
      this.modelsList = [];
      this.modelLoading = false;
      this.serialList = [];
      this.serialLoading = false;
      this.simList = [];
      this.simLoading = false;
      this.selectedSIMs = [];
      this.selectedSerial = [];
      this.paginataionDevices = [];
    },

    //METODOS PARA MANEJAR CAMBIO DE LOS SELECTS ==========================================================================================================

    handleModelChange(rowData) {
      this.devicesList[rowData.rowIndex].Device = rowData.model;
      this.devicesList[rowData.rowIndex].DeviceId = rowData.model.Id;
      this.devicesList[rowData.rowIndex].DeviceModelId = rowData.model.Id;
      this.devicesList[rowData.rowIndex].DeviceTypeId =
        rowData.model.DeviceTypeId;
      // this.devicesList[rowData.rowIndex].DeviceDescription =
      //   rowData.model.Description;

      if (this.Tab == "reallocate") {
        if (
          rowData.model.Id ==
          this.RequestedDevice[rowData.rowIndex].DeviceModelId
        ) {
          this.devicesList[rowData.rowIndex].Serial =
            this.RequestedDevice[rowData.rowIndex].Serial;
          this.devicesList[rowData.rowIndex].SIMNumber =
            this.RequestedDevice[rowData.rowIndex].SIMNumber;
        } else {
          this.devicesList[rowData.rowIndex].Serial = "";
          this.devicesList[rowData.rowIndex].SIMNumber = "";
        }
      }
    },

    handleSerialChange(rowData) {
      const serial = rowData.serial.Serial;
      const serialIndex = rowData.itemIndex;
      const rowIndex = rowData.rowIndex;
      let foundSerial = this.selectedSerial.find((f) => f.row == rowIndex);
      if (foundSerial) {
        this.serialList[foundSerial.serialIndex].disabled = false;
        const foundSerialIndex = this.selectedSerial.findIndex(
          (f) => f.row == rowIndex
        );
        this.selectedSerial.splice(foundSerialIndex, 1);
      }
      let index = this.serialList.findIndex((f) => f.Serial == serial);
      this.serialList[index].disabled = true;

      this.selectedSerial.push({
        serial: serial,
        row: rowIndex,
        serialIndex: serialIndex
      });
      if (this.instalationLines) {
        this.instalationLines[rowIndex].Serial = serial;
      } else {
        this.devicesList[rowIndex].Serial = serial;
      }
    },

    handleSimChange(rowData) {
      const sim = rowData.SIM;
      const simIndex = rowData.itemIndex;
      const rowIndex = rowData.rowIndex;

      let foundSIM = this.selectedSIMs.find((f) => f.row == rowIndex);
      if (foundSIM) {
        this.simList[foundSIM.simIndex].disabled = false;
        const foundSIMIndex = this.selectedSIMs.findIndex(
          (f) => f.row == rowIndex
        );
        this.selectedSIMs.splice(foundSIMIndex, 1);
      }

      let index = this.simList.findIndex(
        (f) => f.PhoneNumber == sim.PhoneNumber
      );
      this.simList[index].disabled = true;

      this.selectedSIMs.push({
        phone: sim.PhoneNumber,
        row: rowIndex,
        simIndex: simIndex
      });

      this.devicesList[rowIndex].IMEI = sim.IMEI;
      this.devicesList[rowIndex].SIMNumber = sim.PhoneNumber;
    },

    formatArrayToElSelect,
    getAvailableDevices() {
      this.serialLoading = true;

      this.$http
        .get("/api/inventory/availableDevices", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            CompanyCode: this.currentCompany,
            LocationCode: this.rowData.Product.Codes,
            AssetType: 1
          }
        })
        .then(({ data }) => {
          const availableDevices = this.formatArrayToElSelect(data, {
            label: "IMEI",
            value: "IMEI"
          });
          this.serialList = availableDevices.slice(0, 20);
          this.serialLoading = false;
        })
        .catch((error) => {
          this.serialLoading = false;
          console.error(error);
        });
    },

    getAvailableSims() {
      this.simLoading = true;

      this.$http
        .get("/api/inventory/availableSims", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            //SE LE MANDA NULO PAR QUE TRAIGA TODO
            PhoneNumber: null,
            DeviceSerial: null,
            CompanyID: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.simList = data.Items;
          this.simLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    //METODOS PARA MANEJAR PAGINACION
    handleSizeChange(/*val*/) {
      //console.log(`${val} items per page`);
    },
    handleCurrentChange(/*val*/) {
      //console.log(`current page: ${val}`);
    }
  },
  computed: {
    getRowData() {
      let deviceChangeRowData = this.rowData;
      return deviceChangeRowData;
    }
  }
};
</script>

<style scoped></style>
